export default "__VITE_ASSET__MlhlO0NL__"